export const UPDATE = "posts/UPDATE";
export const APPEND = "posts/APPEND";
export const PREPEND = "posts/PREPEND";
export const UPDATE_ONE = "posts/UPDATE_ONE";
export const DESTROY = "posts/DESTROY";
export const LOADING = "posts/LOADING";
